import { Col, type ColProps } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import InputField from '../../../../components/fields/InputField';
import SingleUploadField from '../../../../components/fields/SingleUploadField';
import { allowedExtensions } from '../../../../utilities/extensions';

const defaultColSpan = { lg: 8, md: 12, xs: 24 };

export type EnbdBankIntegrationProps = {
    prefix?: string;
    colSpan?: ColProps;
    disabled?: boolean;
};

const fieldNames = [
    'financeManager.name',
    'financeManager.email',
    'companyName',
    'stampRight',
    'stampBottom',
    'dealerCode',
] as const;

const EnbdBankIntegration = ({ prefix, colSpan = defaultColSpan, disabled = false }: EnbdBankIntegrationProps) => {
    const { t } = useTranslation(['bankDetails']);

    const names = useMemo(
        () =>
            Object.fromEntries(fieldNames.map(name => [name, prefix ? `${prefix}.${name}` : name])) as Record<
                (typeof fieldNames)[number],
                string
            >,
        [prefix]
    );

    return (
        <>
            <Col {...colSpan}>
                <InputField
                    {...t('bankDetails:fields.enbdIntegration.companyName', { returnObjects: true })}
                    disabled={disabled}
                    name={names.companyName}
                    required
                />
            </Col>
            <Col {...colSpan}>
                <InputField
                    {...t('bankDetails:fields.enbdIntegration.financeManager.name', { returnObjects: true })}
                    disabled={disabled}
                    name={names['financeManager.name']}
                    required
                />
            </Col>
            <Col {...colSpan}>
                <InputField
                    {...t('bankDetails:fields.enbdIntegration.financeManager.email', { returnObjects: true })}
                    disabled={disabled}
                    name={names['financeManager.email']}
                    required
                />
            </Col>
            <Col {...colSpan}>
                <InputField
                    {...t('bankDetails:fields.bankIntegration.dealerCodeForAudiAndSDM', { returnObjects: true })}
                    disabled={disabled}
                    name={names.dealerCode}
                />
            </Col>
            <Col {...colSpan}>
                <SingleUploadField
                    {...t('bankDetails:fields.enbdIntegration.stampRight', { returnObjects: true })}
                    disabled={disabled}
                    extensions={allowedExtensions.image}
                    name={names.stampRight}
                />
            </Col>
            <Col {...colSpan}>
                <SingleUploadField
                    {...t('bankDetails:fields.enbdIntegration.stampBottom', { returnObjects: true })}
                    disabled={disabled}
                    extensions={allowedExtensions.image}
                    name={names.stampBottom}
                />
            </Col>
        </>
    );
};

export default EnbdBankIntegration;
